import { createRequest, RequestConfig } from 'app/common/api';

import { TPersonData } from '../core/person';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_person',
};

type NewPerson = Omit<TPersonData, 'id'>;

export const addPersonRequest = (body: NewPerson) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
